import React from 'react';
import { FadeIn } from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    title: "Monatliche Zahlungen",
    desc: "Erstellen Sie ein Portfolio, das Ihnen nicht nur einmal im Jahr, sondern jeden Monat Cashflow liefert."
  },
  {
    title: "Die Psychologie des Erfolgs",
    desc: "Warum die meisten Anleger in Krisen scheitern und wie Sie die „Fabrik-Mentalität“ entwickeln, um ruhig zu bleiben."
  },
  {
    title: "Steuer-Kompass DACH",
    desc: "Konkrete Hilfe für Anleger aus Deutschland, Österreich und der Schweiz (inkl. W-8BEN, DA-1 & Broker-Wahl)."
  },
  {
    title: "Analyse-Quick-Check",
    desc: "Lernen Sie die wichtigsten Kennzahlen wie FFO, NII und NAV verstehen, ohne ein Finanzstudium zu benötigen."
  }
];

export const Description = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          
          <div className="w-full lg:w-5/12">
            <FadeIn direction="right">
              <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-6 leading-tight">
                Ein zweites Gehalt, das niemals Urlaub macht.
              </h2>
              <div className="w-16 h-1 bg-gold mb-8"></div>
              
              <div className="prose prose-lg text-gray-600 font-sans">
                <p className="mb-4 font-semibold text-navy">
                  Haben Sie genug von unsicheren Börsenkursen? Lassen Sie Ihr Geld endlich für sich arbeiten – Monat für Monat!
                </p>
                <p className="mb-4">
                  Marc Arndt präsentiert Ihnen mit „Der Dividenden-Investor“ ein glasklares Framework, wie Sie sich ein privates Einkommens-Depot aufbauen, das Ihnen regelmäßige Dividenden ausschüttet.
                </p>
                <p>
                  Dieses Buch ist kein theoretisches Lehrbuch. Es ist eine <strong className="text-navy">Schritt-für-Schritt-Anleitung</strong> für Menschen, die Fakten auf dem Konto sehen wollen.
                </p>
              </div>
            </FadeIn>
          </div>

          <div className="w-full lg:w-7/12">
            <FadeIn direction="left" delay={0.2}>
              <div className="bg-white p-8 md:p-10 rounded-2xl shadow-luxury border border-gray-100">
                <h3 className="font-serif text-2xl text-navy font-bold mb-8">Was Sie in diesem Praxis-Guide lernen:</h3>
                
                <div className="space-y-6">
                  {features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-4">
                      <div className="flex-shrink-0 mt-1 w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center">
                        <SafeIcon icon={FiIcons.FiCheck} className="text-gold text-lg" />
                      </div>
                      <div>
                        <h4 className="font-serif font-bold text-navy text-lg mb-1">{feature.title}</h4>
                        <p className="font-sans text-gray-600 text-sm leading-relaxed">{feature.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </FadeIn>
          </div>

        </div>
      </div>
    </section>
  );
};